import { render, staticRenderFns } from "./Ebook_dtail.vue?vue&type=template&id=4fc017de"
import script from "./Ebook_dtail.vue?vue&type=script&lang=js"
export * from "./Ebook_dtail.vue?vue&type=script&lang=js"
import style0 from "./Ebook_dtail.vue?vue&type=style&index=0&id=4fc017de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports